import { HttpClient } from "@angular/common/http";
import { Injector } from "@angular/core";
import { Store } from "@ngxs/store";

import { environment } from "src/environments/environment";
import { AlertService } from "src/app/services/alert/alert.service";
import { MessageBannerService } from "src/app/components/messages/services/message-banner.service";
import { Observable, Subscription } from "rxjs";
import { AppStateService } from "src/app/store/app-state-service";
import { User } from "src/app/components/catalogs/user-catalog/services/user";
import { utils } from "src/app/modules/libs/utils";
import { MatDialog } from "@angular/material/dialog";
import { MessageBanner } from "src/app/components/messages/services/message-banner";
import { Role } from "src/app/components/catalogs/roles/services/role";
import { Roles } from "../enumerations/enumerations";
import { PrivilegeEnum } from "src/app/common/enumerations/privilege-enum";
import { TokenInfoService } from "src/app/services/authentication/token-info.service";
import { YesNoDialogComponent } from "src/app/controls/yes-no-dialog/yes-no-dialog.component";

export class BaseService<T, K> {

  BASE_URL = environment.urls.baseApiUrl; // Api URL
  URL!: string;

  private _mbs!: MessageBannerService;
  private _ass!: AppStateService;
  private _tis!: TokenInfoService;
  http!: HttpClient;
  store!: Store;
  alert!: AlertService;
  utils = utils;
  dialog!: MatDialog;

  subs: Subscription = new Subscription;
  public currentUser!: User | null;

  public users: User[] = [];
  private users$!: Observable<User[]>;
  private usersSubs: Subscription = new Subscription;

  constructor(
    protected injector: Injector,
    protected endpoint: string
  ) {
    this.http = this.injector.get(HttpClient);
    this._mbs = this.injector.get(MessageBannerService);
    this._ass = this.injector.get(AppStateService);
    this.store = this.injector.get(Store);
    this.alert = this.injector.get(AlertService);
    this.dialog = this.injector.get(MatDialog);
    this._tis = this.injector.get(TokenInfoService);

    this.URL = this.BASE_URL + endpoint;
    this.subs = this._ass.AppState.subscribe(appstate => {
      this.currentUser = appstate?.currentUser;
      this.currentUserUpdated();
    });
    this.loadUsers();
  }

  currentUserUpdated(): void {
    // this.method show be overridden in derived class to trigger other methos when user updates!
  };

  create(data: T): Observable<T> {
    return this.http.post<T>(this.URL, data);
  }

  createRange(data: T[]): Observable<T[]> {
    return this.http.post<T[]>(this.URL + '/range', data);
  }

  getAll(): Observable<T[]> {
    return this.http.get<T[]>(this.URL);
  }

  getById(id: K, options?: { showLoading?: boolean }): Observable<T> {
    // let ctx = new HttpContext();
    // if (options?.showLoading === false)
    //   ctx = ctx.set(SHOW_LOADING, false);

    return this.http.get<T>(this.URL + '/' + id);
  }

  update(data: T): Observable<T> {
    return this.http.put<T>(this.URL, data);
  }

  delete(id: K): Observable<any> {
    return this.http.delete<T>(this.URL + '/' + id);
  }

  hasPrivilege(privilege: PrivilegeEnum): boolean {
    return this._tis.hasPrivilege(privilege) ?? false;
  }

  hasRoles(roles?: Role[] | Roles[] | number[] | null) {
    if (!roles) return false;
    let roleIds = [];

    if (roles.some((r: any) => this.isRole(r))) {
      roleIds = (roles as Role[]).map((r: Role) => r?.id);
    } else {
      roleIds = roles as number[];
    }
    const intersect = utils.intersect(this.currentUser?.userRole?.map((x) => x.roleID), roleIds);
    return intersect;
  }

  private isRole(r: any) {
    return typeof r == 'object';
  }

  isSA() {
    return this.hasRoles([Roles.SA]) ?? false;
  }

  loadUsers() {
    this.users$ = this.store.select(state => state.Users.data);
    this.usersSubs = this.users$.subscribe(data => {
      if (data?.length) {
        this.users = data;
      }
    });
  }

  getMessage(val: number | string): MessageBanner {
    if (typeof (val) === 'string')
      return this._mbs.get(val);
    return new MessageBanner();
  }

  getUsers() {
    this.loadUsers();
    return this.users ?? [];
  }

  getUser(id?: number) {
    this.getUsers();
    return this.users.find(u => u.id == id);
  }

  showDialog(confirmMessage: { message: string, icon: string }): Promise<boolean> {
    const confirm = this.dialog.open(YesNoDialogComponent, {
      width: "500px",
      data: confirmMessage,
    });

    return new Promise(resolve => {
      confirm.afterClosed().subscribe(data => resolve(!!data));
    });
  }
}
